export const setNotifInternalFalse = (notifInteral) => ({
  ...notifInteral,
  loading: false,
  loadingMessage: null,
});
